/*
  "Notify when available" on product cards and in the quick-add popup.

  Markup comes from snippets/magnum-notify.liquid. The sign-up goes straight to
  Klaviyo's back-in-stock list - the same list the product page's Klaviyo popup
  fills - so the "it's back" email goes out the same way whichever one the
  shopper used.
*/
if (!customElements.get('magnum-notify')) {
  const KLAVIYO_ACCOUNT = 'W9kFLP';

  customElements.define(
    'magnum-notify',
    class MagnumNotify extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;

        this.openButton = this.querySelector('[data-mn-open]');
        this.form = this.querySelector('[data-mn-form]');
        this.email = this.querySelector('[data-mn-email]');
        this.send = this.querySelector('[data-mn-send]');
        this.done = this.querySelector('[data-mn-done]');
        this.error = this.querySelector('[data-mn-error]');

        this.openButton.addEventListener('click', () => {
          this.openButton.hidden = true;
          this.form.hidden = false;
          this.email.focus();
        });

        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.signUp();
        });
      }

      /* The popup calls this as the shopper picks a different sold-out choice. */
      setVariant(id) {
        if (String(id) === this.dataset.variantId) return;
        this.dataset.variantId = id;
        this.reset();
      }

      reset() {
        this.openButton.hidden = false;
        this.form.hidden = true;
        this.done.hidden = true;
        this.error.hidden = true;
      }

      showError(message) {
        this.error.textContent = message;
        this.error.hidden = false;
      }

      async signUp() {
        const email = this.email.value.trim();
        this.error.hidden = true;

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          this.showError('Please enter a valid email address.');
          this.email.focus();
          return;
        }

        this.send.disabled = true;

        try {
          const response = await fetch(
            `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${KLAVIYO_ACCOUNT}`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/vnd.api+json',
                revision: '2025-01-15',
              },
              body: JSON.stringify({
                data: {
                  type: 'back-in-stock-subscription',
                  attributes: {
                    channels: ['EMAIL'],
                    profile: { data: { type: 'profile', attributes: { email } } },
                  },
                  relationships: {
                    variant: {
                      data: {
                        type: 'catalog-variant',
                        id: `$shopify:::$default:::${this.dataset.variantId}`,
                      },
                    },
                  },
                },
              }),
            }
          );

          if (!response.ok) throw new Error(response.status);

          this.form.hidden = true;
          this.done.hidden = false;
        } catch (error) {
          this.showError("Sorry, that didn't go through. Please try again.");
        } finally {
          this.send.disabled = false;
        }
      }
    }
  );
}
